export const defaultTrustStatuses = ['Unknown', 'InProgress', 'Trusted'];

// Spans must add up to DEVICE_WIN32_APPS_COLUMNS; the column each group ends on carries groupEnd.
export const DEVICE_WIN32_APPS_COLUMN_GROUPS = [{ title: 'Application details', span: 5 }];

// sortKey is resolved by WdacRepository.ApplyOrdering on the wdacResults endpoint. Status has no
// ordering there, so it is the one unsortable column. Version sorts as text, so 10.0 precedes 9.0.
export const DEVICE_WIN32_APPS_COLUMNS = [
  { key: 'arpDisplayName', label: 'Name', sortable: true, sortKey: 'name', width: '24%' },
  { key: 'arpDisplayVersion', label: 'Version', sortable: true, sortKey: 'version', width: '14%' },
  {
    key: 'arpPublisher',
    label: 'Publisher',
    sortable: true,
    sortKey: 'publisher',
    width: '22%',
  },
  { key: 'lastSeen', label: 'Last Seen', sortable: true, sortKey: 'lastSeen', width: '20%' },
  { key: 'status', label: 'Trust Status', groupEnd: true, width: '20%' },
];
